// extracted by mini-css-extract-plugin
module.exports = {"title":"entrystyle_title__3-Xef","titleHeader":"entrystyle_titleHeader__2uU_L","header":"entrystyle_header__2RUPr","headerText":"entrystyle_headerText__3uhNj"};